var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { AccountCircle, Add, CallOutlined, ChevronLeft, ChevronRight, EmailOutlined, MessageOutlined, SentimentSatisfiedOutlined, SentimentVeryDissatisfiedOutlined, SentimentVerySatisfiedOutlined, WhatsApp } from '@mui/icons-material';
import { capitalize, cardHeaderClasses, Chip, Stack, Typography } from '@mui/material';
import { GridActionsCellItem } from '@mui/x-data-grid';
import dayjs from 'dayjs';
import { useCallback, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { DynamicFormBuilderContainer } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { LOCAL_STORAGE_KEYS } from '../../../constants';
import { showSurface } from '../../../redux/awaitedSurfacesSlice';
import { deleteState } from '../../../redux/crudSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { info, secondary, purple } from '../../../theme/colors';
import { getLocalStorageItem } from '../../../utils/storageHelper';
import CreateAppointment from '../../appointmentV3/pages/createAppointment';
import ProgressStartArrow from './assets/progressStartArrow';
import StarMagicIcon from './assets/starMagicIcon';
import CommunicationTimeline from './components/communicationTimeline';
import LeadStageToggleButton from './components/leadStageToggleButton';
import NPSScoreSlider from './components/npsScoreSlider';
import { crmAiScriptGen, crmCustomerProfileGet, CRMKeys } from './services/apiCalls';
import { LanguageOptions, LeadStageOptions, LeadStageStatusOptions } from './services/entity';
import CommunicationTemplateForm from './components/communicationDialog';
var getMood = function (value) {
    if (value < 6)
        return /*#__PURE__*/ React.createElement(SentimentVeryDissatisfiedOutlined, {
            color: "error",
            fontSize: "inherit"
        });
    if (value < 9)
        return /*#__PURE__*/ React.createElement(SentimentSatisfiedOutlined, {
            color: "warning",
            fontSize: "inherit"
        });
    if (value < 11)
        return /*#__PURE__*/ React.createElement(SentimentVerySatisfiedOutlined, {
            color: "success",
            fontSize: "inherit"
        });
};
export default function CrmCustomerProfile(props) {
    var _a;
    var _this = this;
    var _getLocalStorageItem, _crud$CRMKeys$aiScrip;
    var request = props.request;
    var id = useParams().id;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var branch = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.Branches[0];
    var crud = useAppSelector(function (state) { return state.crud; });
    useEffect(function () {
        return function () {
            dispatch(deleteState({
                key: CRMKeys.aiScript
            }));
            dispatch(deleteState({
                key: CRMKeys.get
            }));
        };
    }, []);
    var handleCommunicationsClick = useCallback(function (state, val, field) {
        var _state$FirstName, _state$LastName, _state$Vehicle;
        dispatch(showSurface({
            type: 'Dialog',
            Component: CommunicationTemplateForm,
            componentProps: {
                request: {
                    ChannelType: field.name,
                    CustomerId: state === null || state === void 0 ? void 0 : state.id,
                    CommunicationDate: dayjs().toISOString(),
                    OrganizationId: branch === null || branch === void 0 ? void 0 : branch.OrganizationId,
                    ParentOrganizationId: branch === null || branch === void 0 ? void 0 : branch.ParentOrganizationId,
                    Email: state === null || state === void 0 ? void 0 : state.Email,
                    MobileNumber: state === null || state === void 0 ? void 0 : state.MobileNumber,
                    Name: "".concat(capitalize(state === null || state === void 0 || (_state$FirstName = state.FirstName) === null || _state$FirstName === void 0 ? void 0 : _state$FirstName.toLowerCase()), " ").concat(capitalize(state === null || state === void 0 || (_state$LastName = state.LastName) === null || _state$LastName === void 0 ? void 0 : _state$LastName.toLowerCase())),
                    VinNo: state === null || state === void 0 || (_state$Vehicle = state.Vehicle) === null || _state$Vehicle === void 0 ? void 0 : _state$Vehicle.Vin
                }
            },
            containerProps: {
                maxWidth: 'xs',
                fullWidth: true,
                disableEscapeKeyDown: true,
                onClose: function () { }
            }
        }));
        return undefined;
    }, [branch === null || branch === void 0 ? void 0 : branch.OrganizationId]);
    var summaryButtonProps = useCallback(function (state, val, label) {
        var diff = dayjs(val).diff(undefined, 'days');
        var dayString = dayjs(val).format('DD MMM, YYYY');
        var color = 'secondary';
        if (diff <= 1 && diff >= -21)
            color = 'error';
        else if (diff <= 21 && diff > 1)
            color = 'warning';
        return {
            type: FormItemTypes.Button,
            color: color,
            children: /*#__PURE__*/ React.createElement(Stack, {
                direction: "row",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%"
            }, label, /*#__PURE__*/ React.createElement(Typography, {
                fontWeight: "medium"
            }, " ", dayString))
        };
    }, []);
    var eventButtonProps = useCallback(function (state, val) {
        var _date;
        var dob = dayjs(state === null || state === void 0 ? void 0 : state.DateOfBirth);
        var doa = dayjs(val);
        var date;
        var children;
        if (val && doa.isBefore(dob)) {
            date = doa;
            children = 'Marriage anniversary';
        }
        else {
            date = dob;
            children = 'Birthdate';
        }
        var color = 'secondary';
        if (date.diff(null, 'days') <= 1)
            color = 'primary';
        return {
            type: FormItemTypes.Button,
            color: color,
            children: /*#__PURE__*/ React.createElement(Stack, {
                direction: "row",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%"
            }, children, /*#__PURE__*/ React.createElement(Typography, {
                fontWeight: "medium"
            }, " ", (_date = date) === null || _date === void 0 ? void 0 : _date.format('DD MMM')))
        };
    }, []);
    var serviceHistoryListColumns = [{
            type: 'string',
            field: 'NPSScore',
            align: 'right',
            width: 30,
            minWidth: 10,
            renderCell: function (_ref) {
                var value = _ref.value;
                return getMood(value);
            }
        }, {
            type: 'string',
            field: 'ServiceDate',
            valueFormatter: function (val) { return dayjs(val).format('DD MMM, YYYY'); },
            flex: 1,
            renderCell: function (_ref2) {
                var row = _ref2.row, formattedValue = _ref2.formattedValue;
                return /*#__PURE__*/ React.createElement(Stack, {
                    direction: "column"
                }, /*#__PURE__*/ React.createElement(Typography, {
                    fontSize: "inherit"
                }, formattedValue), /*#__PURE__*/ React.createElement(Typography, {
                    fontSize: "xs",
                    color: "secondary"
                }, row === null || row === void 0 ? void 0 : row.OrganizationName));
            }
        }, {
            type: 'string',
            field: 'ServiceTypeName',
            align: 'right',
            flex: 1
        }, {
            type: 'actions',
            field: 'actions',
            align: 'left',
            getActions: function () { return [/*#__PURE__*/ React.createElement(GridActionsCellItem, {
                    label: "more",
                    icon: /*#__PURE__*/ React.createElement(ChevronRight, {
                        fontSize: "small",
                        color: "secondary"
                    })
                })]; },
            width: 40,
            minWidth: 20
        }];
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: 'leftPanel',
            columnSize: 3,
            bgcolor: '#fff',
            spacing: 0,
            pb: 8,
            alignContent: 'flex-start',
            borderRight: '1px solid ' + secondary[200],
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: 'ProfileDetails',
                    columnSize: 12,
                    p: 2,
                    spacing: 0,
                    elements: [{
                            type: FormItemTypes.Button,
                            name: 'Back',
                            children: 'Back to leads',
                            startIcon: /*#__PURE__*/ React.createElement(ChevronLeft, {
                                fontSize: "small"
                            }),
                            color: 'secondary',
                            size: 'small',
                            sx: {
                                p: 0.25
                            },
                            columnSize: 12,
                            onClick: function () {
                                navigate('/crmdashboard');
                            }
                        }, {
                            type: FormItemTypes.Chip,
                            name: 'ServiceDropProbability',
                            variant: 'filled',
                            size: 'small',
                            columnSize: true,
                            setFieldProps: function (state, val) {
                                var color = 'success';
                                switch (val) {
                                    case 'High':
                                        color = 'error';
                                        break;
                                    case 'Medium':
                                        color = 'warning';
                                        break;
                                }
                                return {
                                    type: FormItemTypes.Chip,
                                    color: color,
                                    label: val ? val + ' risk' : ''
                                };
                            }
                        }, {
                            type: FormItemTypes.Chip,
                            name: 'AMCName',
                            variant: 'filled',
                            size: 'small',
                            columnSize: 0,
                            color: 'purple',
                            setFieldProps: function (state) {
                                var _state$CRMAMC;
                                var val = state === null || state === void 0 || (_state$CRMAMC = state.CRMAMC) === null || _state$CRMAMC === void 0 || (_state$CRMAMC = _state$CRMAMC[0]) === null || _state$CRMAMC === void 0 ? void 0 : _state$CRMAMC.Name;
                                return {
                                    type: FormItemTypes.Chip,
                                    label: val
                                };
                            }
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'dp',
                            columnSize: 12,
                            align: 'center',
                            lineHeight: 0,
                            children: /*#__PURE__*/ React.createElement(AccountCircle, {
                                color: "secondary",
                                sx: {
                                    fontSize: 40
                                }
                            })
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'Name',
                            columnSize: 12,
                            align: 'center',
                            fontWeight: 'strong',
                            valueGetter: function (state) { return "".concat(state.FirstName, " ").concat(state.LastName); }
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'Code',
                            label: 'Customer ID:',
                            columnSize: 12,
                            align: 'center',
                            fontSize: 'sm',
                            color: info[500],
                            noWrap: true,
                            flexWrap: 'nowrap',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'center',
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true
                            }
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'LoyaltyPoints',
                            label: 'Loyalty points:',
                            columnSize: 12,
                            align: 'center',
                            fontSize: 'sm',
                            fontWeight: 'medium',
                            noWrap: true,
                            flexWrap: 'nowrap',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'center',
                                gap: 1
                            }
                        }]
                }, {
                    type: FormItemTypes.Divider,
                    name: '',
                    variant: 'fullWidth',
                    sx: {
                        bgcolor: 'secondary'
                    },
                    columnSize: 12
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: 'Vehicle',
                    columnSize: 12,
                    p: 2,
                    spacing: 0,
                    rowSpacing: 0.5,
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            columnSize: true,
                            children: 'Vehicle details',
                            fontSize: 'lg',
                            fontWeight: 'strong',
                            mb: 2
                        },
                        // {
                        //     type: FormItemTypes.Button,
                        //     name: 'PrevVehicle',
                        //     columnSize: 0,
                        //     size: 'small',
                        //     children: <>View More <ChevronRight /> </>,
                        //     sx: { p: '0px !important', fontSize: 'sm' }
                        // },
                        {
                            type: FormItemTypes.Typography,
                            name: 'RegistrationNumber',
                            label: 'Registration',
                            columnSize: 12,
                            color: info[500],
                            noWrap: true,
                            flexWrap: 'nowrap',
                            fontWeight: 'medium',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true
                            },
                            valueGetter: function (state) {
                                var _state$Vehicle2;
                                return state === null || state === void 0 || (_state$Vehicle2 = state.Vehicle) === null || _state$Vehicle2 === void 0 ? void 0 : _state$Vehicle2.RegistrationNo;
                            }
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'ProductName',
                            label: 'Model',
                            columnSize: 12,
                            noWrap: true,
                            flexWrap: 'nowrap',
                            fontWeight: 'medium',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                gap: 1
                            },
                            valueGetter: function (state) {
                                var _state$Vehicle3;
                                return state === null || state === void 0 || (_state$Vehicle3 = state.Vehicle) === null || _state$Vehicle3 === void 0 ? void 0 : _state$Vehicle3.ProductName;
                            }
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'PurchaseDate',
                            label: 'Purchase Date',
                            value: '22 Jan, 2020',
                            columnSize: 12,
                            noWrap: true,
                            flexWrap: 'nowrap',
                            fontWeight: 'medium',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                gap: 1
                            },
                            valueGetter: function (state) {
                                var _state$Vehicle4;
                                return dayjs(state === null || state === void 0 || (_state$Vehicle4 = state.Vehicle) === null || _state$Vehicle4 === void 0 ? void 0 : _state$Vehicle4.SellingInvoiceDate).format('DD MMM, YYYY');
                            }
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'Odometer',
                            label: 'Last odometer rating',
                            columnSize: 12,
                            noWrap: true,
                            flexWrap: 'nowrap',
                            fontWeight: 'medium',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                gap: 1
                            },
                            valueGetter: function (state) {
                                var _state$Vehicle5;
                                return (state === null || state === void 0 || (_state$Vehicle5 = state.Vehicle) === null || _state$Vehicle5 === void 0 ? void 0 : _state$Vehicle5.LastKMReading) + ' KM';
                            }
                        }]
                }, {
                    type: FormItemTypes.Divider,
                    name: '',
                    variant: 'fullWidth',
                    sx: {
                        bgcolor: 'secondary'
                    },
                    columnSize: 12
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: 'Customer',
                    columnSize: 12,
                    p: 2,
                    spacing: 0.5,
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            columnSize: true,
                            children: 'Customer details',
                            fontSize: 'lg',
                            fontWeight: 'strong',
                            mb: 2
                        },
                        // {
                        //     type: FormItemTypes.Button,
                        //     name: 'PrevVehicle',
                        //     columnSize: 0,
                        //     size: 'small',
                        //     children: <>View More <ChevronRight /> </>,
                        //     sx: { p: 0.25, fontSize: 'sm' }
                        // },
                        {
                            type: FormItemTypes.Typography,
                            name: 'Gender',
                            label: 'Gender',
                            columnSize: 12,
                            noWrap: true,
                            flexWrap: 'nowrap',
                            fontWeight: 'medium',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true
                            }
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'DateOfBirth',
                            label: 'Date Of Birth',
                            columnSize: 12,
                            noWrap: true,
                            flexWrap: 'nowrap',
                            fontWeight: 'medium',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                gap: 1
                            },
                            valueGetter: function (state, field) {
                                var _field$name;
                                return dayjs(state === null || state === void 0 ? void 0 : state[(_field$name = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name !== void 0 ? _field$name : '']).format("DD MMM");
                            }
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'Age',
                            label: 'Age',
                            columnSize: 12,
                            noWrap: true,
                            flexWrap: 'nowrap',
                            fontWeight: 'medium',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                gap: 1
                            },
                            valueGetter: function (state, field) { return dayjs().diff(state === null || state === void 0 ? void 0 : state.DateOfBirth, 'years'); }
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'MaritalStatus',
                            label: 'Marital Status',
                            columnSize: 12,
                            noWrap: true,
                            flexWrap: 'nowrap',
                            fontWeight: 'medium',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                gap: 1
                            }
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'DateofAnniversary',
                            label: 'Anniversary Date',
                            columnSize: 12,
                            noWrap: true,
                            flexWrap: 'nowrap',
                            fontWeight: 'medium',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                gap: 1
                            },
                            valueGetter: function (state, field) {
                                var _field$name2, _field$name3;
                                return (state === null || state === void 0 ? void 0 : state[(_field$name2 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name2 !== void 0 ? _field$name2 : '']) && dayjs(state === null || state === void 0 ? void 0 : state[(_field$name3 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name3 !== void 0 ? _field$name3 : '']).format('DD MMM');
                            }
                        }]
                }, {
                    type: FormItemTypes.Divider,
                    name: '',
                    variant: 'fullWidth',
                    sx: {
                        bgcolor: 'secondary'
                    },
                    columnSize: 12
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    p: 2,
                    spacing: 0,
                    rowSpacing: 3,
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            columnSize: 12,
                            children: 'NPS score',
                            fontSize: 'lg',
                            fontWeight: 'strong'
                        }, {
                            type: FormItemTypes.Custom,
                            name: 'NPS',
                            columnSize: 12,
                            containerProps: {
                                mx: 1
                            },
                            element: NPSScoreSlider
                        }]
                }, {
                    type: FormItemTypes.Divider,
                    name: '',
                    variant: 'fullWidth',
                    sx: {
                        bgcolor: 'secondary'
                    },
                    columnSize: 12
                },
                // divider
                {
                    type: FormItemTypes.Accordian,
                    name: 'RiderAccordian',
                    columnSize: 12,
                    value: false,
                    sx: {
                        border: 'none'
                    },
                    summary: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            columnSize: 0,
                            children: 'Rider',
                            fontSize: 'lg',
                            fontWeight: 'strong'
                        }],
                    elements: [{
                            type: FormItemTypes.CardComponent,
                            name: '',
                            columnSize: 12,
                            contentProps: {
                                spacing: 0
                            },
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: 'DriverName',
                                    fontWeight: 'strong',
                                    columnSize: 12,
                                    value: 'Rider'
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'DriverNo',
                                    columnSize: 12,
                                    fontSize: 'sm',
                                    color: 'text.tertiary'
                                }]
                        }]
                }, {
                    type: FormItemTypes.Divider,
                    name: '',
                    variant: 'fullWidth',
                    sx: {
                        bgcolor: 'secondary'
                    },
                    columnSize: 12
                } // divider
            ]
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'mainPanel',
            columnSize: 6,
            p: 2,
            spacing: 0,
            rowSpacing: 2,
            alignContent: 'flex-start',
            elements: [{
                    type: FormItemTypes.CardComponent,
                    name: '',
                    columnSize: 12,
                    contentProps: {
                        spacing: 0,
                        rowGap: 1
                    },
                    elements: [{
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            justifyContent: 'space-between',
                            columnSize: 12,
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    children: 'Lead stage',
                                    fontSize: 'lg',
                                    fontWeight: 'strong',
                                    columnSize: 0
                                }, {
                                    type: FormItemTypes.Custom,
                                    name: 'LeadStageCategory',
                                    columnSize: 0,
                                    element: LeadStageToggleButton,
                                    setFormState: function (state, curr) { return ({
                                        LeadStageStatus: curr === null || curr === void 0 ? void 0 : curr.Status,
                                        IncludeStage: (curr === null || curr === void 0 ? void 0 : curr.Status) > -1
                                    }); }
                                }]
                        }, {
                            type: FormItemTypes.CheckBox,
                            label: 'Interested',
                            name: 'IncludeStage',
                            value: null,
                            columnSize: true,
                            containerProps: {
                                display: 'flex',
                                justifyContent: 'flex-end'
                            },
                            setFormState: function (state, val) {
                                var _state$LeadStageCateg;
                                LeadStageOptions[state === null || state === void 0 || (_state$LeadStageCateg = state.LeadStageCategory) === null || _state$LeadStageCateg === void 0 ? void 0 : _state$LeadStageCateg.id].Status = 0;
                                return {
                                    LeadStageStatus: 0
                                };
                            }
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: 'LeadStageStatus',
                            justifyContent: 'space-between',
                            columnSize: 12,
                            spacing: 0,
                            setFieldProps: function (state, val) { return ({
                                type: FormItemTypes.ContainerItem,
                                elements: LeadStageStatusOptions.map(function (it, i) { return ({
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    columnSize: 4,
                                    children: /*#__PURE__*/ React.createElement(ProgressStartArrow, {
                                        sx: {
                                            color: i > val ? secondary[100] : info[500]
                                        }
                                    }),
                                    containerProps: {
                                        position: 'relative'
                                    },
                                    label: it,
                                    labelTypographyProps: {
                                        color: i > val ? 'ButtonText' : 'white',
                                        fontSize: 'base',
                                        fontWeight: 'medium',
                                        mb: 0,
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        sx: {
                                            transform: 'translate(-50%,-60%)',
                                            textWrap: 'nowrap'
                                        }
                                    }
                                }); })
                            }); }
                        }]
                }, {
                    type: FormItemTypes.CardComponent,
                    name: '',
                    label: /*#__PURE__*/ React.createElement(React.Fragment, null, "AI Script", /*#__PURE__*/ React.createElement(Typography, {
                        ml: 1,
                        fontSize: "sm",
                        color: purple[400],
                        display: "inline-flex",
                        alignItems: "center"
                    }, "Powered by Excellon AI", /*#__PURE__*/ React.createElement(StarMagicIcon, {
                        color: "inherit",
                        sx: {
                            height: 14
                        }
                    }))),
                    columnSize: 12,
                    contentProps: {
                        spacing: 0,
                        rowGap: 1,
                        py: 1
                    },
                    sx: (_a = {},
                        _a["&>.".concat(cardHeaderClasses.root)] = {
                            borderBottom: '1px solid ' + secondary[200],
                            px: 2.5
                        },
                        _a),
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            children: 'Call script',
                            fontWeight: 'strong',
                            columnSize: true
                        }, {
                            type: FormItemTypes.SingleSelect,
                            name: 'Language',
                            value: 'English',
                            options: LanguageOptions,
                            valueExpr: 'Language',
                            displayExpr: 'DisplayName',
                            size: 'small',
                            columnSize: 0,
                            variant: 'standard',
                            color: 'secondary',
                            sx: {
                                color: 'text.tertiary'
                            },
                            disableUnderline: true,
                            setFormState: function (state, val) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    crmAiScriptGen({
                                        request: _objectSpread(_objectSpread({}, state), {}, {
                                            Language: val === null || val === void 0 ? void 0 : val.Language
                                        })
                                    });
                                    return [2 /*return*/];
                                });
                            }); },
                            disabled: crud["isLoading".concat(CRMKeys.aiScript)] === 'loading'
                        }, {
                            type: FormItemTypes.CardComponent,
                            name: '',
                            columnSize: 12,
                            sx: {
                                background: purple[900],
                                maxHeight: 300,
                                overflowY: 'auto',
                                border: '1px solid ' + purple[400]
                            },
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: 'AIScript',
                                    columnSize: 12,
                                    component: 'pre',
                                    textAlign: 'justify',
                                    color: 'white',
                                    sx: {
                                        textWrap: 'wrap'
                                    },
                                    value: crud["isLoading".concat(CRMKeys.aiScript)] !== 'loading' ? (_crud$CRMKeys$aiScrip = crud[CRMKeys.aiScript]) === null || _crud$CRMKeys$aiScrip === void 0 ? void 0 : _crud$CRMKeys$aiScrip.data : null
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'LoadingScript',
                                    columnSize: 12,
                                    component: 'pre',
                                    textAlign: 'justify',
                                    color: 'white',
                                    sx: {
                                        textWrap: 'wrap'
                                    },
                                    value: crud["isLoading".concat(CRMKeys.aiScript)] === 'loading' ? 'Loading Script...' : undefined
                                }]
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 12,
                            spacing: 1.5,
                            pt: 1,
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    children: 'Summary',
                                    fontWeight: 'strong',
                                    columnSize: 12
                                }, {
                                    type: FormItemTypes.Button,
                                    name: 'DateofAnniversary',
                                    variant: 'outlined',
                                    fullWidth: true,
                                    md: 6,
                                    sm: 12,
                                    size: 'small',
                                    endIcon: /*#__PURE__*/ React.createElement(ChevronRight, null),
                                    setFieldProps: eventButtonProps
                                }, {
                                    type: FormItemTypes.Button,
                                    name: 'WarrantyExpiry',
                                    color: 'secondary',
                                    variant: 'outlined',
                                    fullWidth: true,
                                    md: 6,
                                    sm: 12,
                                    size: 'small',
                                    endIcon: /*#__PURE__*/ React.createElement(ChevronRight, null),
                                    setFieldProps: function (state, val) { return summaryButtonProps(state, val, 'Warranty Expiry'); }
                                }, {
                                    type: FormItemTypes.Button,
                                    name: 'ServiceDue',
                                    color: 'secondary',
                                    variant: 'outlined',
                                    fullWidth: true,
                                    md: 6,
                                    sm: 12,
                                    size: 'small',
                                    endIcon: /*#__PURE__*/ React.createElement(ChevronRight, null),
                                    setFieldProps: function (state, val) { return summaryButtonProps(state, val, 'Service due'); }
                                }, {
                                    type: FormItemTypes.Button,
                                    name: 'InsuranceDue',
                                    color: 'secondary',
                                    variant: 'outlined',
                                    fullWidth: true,
                                    md: 6,
                                    sm: 12,
                                    size: 'small',
                                    endIcon: /*#__PURE__*/ React.createElement(ChevronRight, null),
                                    setFieldProps: function (state, val) { return summaryButtonProps(state, val, 'Insurance due'); }
                                }]
                        }]
                } // AI Script
            ]
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'rightPanel',
            columnSize: 3,
            spacing: 0,
            bgcolor: '#fff',
            alignContent: 'flex-start',
            borderLeft: '1px solid ' + secondary[200],
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: 'Communication',
                    columnSize: 12,
                    p: 2,
                    justifyContent: 'start',
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            columnSize: true,
                            children: 'Call Preference',
                            fontSize: 'lg',
                            fontWeight: 'strong'
                        }, {
                            type: FormItemTypes.Button,
                            name: 'Notes',
                            columnSize: 0,
                            size: 'small',
                            color: 'secondary',
                            children: /*#__PURE__*/ React.createElement(React.Fragment, null, "Notes ", /*#__PURE__*/ React.createElement(Add, null), " "),
                            sx: {
                                p: 0.25,
                                fontSize: 'base'
                            },
                            containerProps: {
                                display: 'flex',
                                alignItems: 'center'
                            },
                            setFormState: handleCommunicationsClick
                        }, {
                            type: FormItemTypes.CardComponent,
                            name: '',
                            columnSize: 12,
                            sx: {
                                p: 1
                            },
                            contentProps: {
                                spacing: 0
                            },
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: 'Days',
                                    label: 'Days: ',
                                    columnSize: 12,
                                    fontSize: 'sm',
                                    color: info[500],
                                    noWrap: true,
                                    flexWrap: 'nowrap',
                                    fontWeight: 'medium',
                                    containerProps: {
                                        display: 'inline-flex',
                                        gap: 1
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true
                                    },
                                    valueGetter: function (state, field) {
                                        var _state$CallPreference, _field$name4;
                                        return state === null || state === void 0 || (_state$CallPreference = state.CallPreference) === null || _state$CallPreference === void 0 ? void 0 : _state$CallPreference[(_field$name4 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name4 !== void 0 ? _field$name4 : ''];
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'Time',
                                    label: 'Time: ',
                                    columnSize: 12,
                                    fontSize: 'sm',
                                    color: info[500],
                                    noWrap: true,
                                    flexWrap: 'nowrap',
                                    fontWeight: 'medium',
                                    containerProps: {
                                        display: 'inline-flex',
                                        gap: 1
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true
                                    },
                                    valueGetter: function (state, field) {
                                        var _state$CallPreference2, _field$name5;
                                        return state === null || state === void 0 || (_state$CallPreference2 = state.CallPreference) === null || _state$CallPreference2 === void 0 ? void 0 : _state$CallPreference2[(_field$name5 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name5 !== void 0 ? _field$name5 : ''];
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'Language',
                                    label: 'Language: ',
                                    columnSize: 12,
                                    fontSize: 'sm',
                                    color: info[500],
                                    noWrap: true,
                                    flexWrap: 'nowrap',
                                    fontWeight: 'medium',
                                    containerProps: {
                                        display: 'inline-flex',
                                        gap: 1
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true
                                    },
                                    valueGetter: function (state, field) {
                                        var _state$CallPreference3, _field$name6;
                                        return state === null || state === void 0 || (_state$CallPreference3 = state.CallPreference) === null || _state$CallPreference3 === void 0 ? void 0 : _state$CallPreference3[(_field$name6 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name6 !== void 0 ? _field$name6 : ''];
                                    }
                                }]
                        }, {
                            type: FormItemTypes.Button,
                            name: 'SMS',
                            label: 'SMS',
                            columnSize: 3,
                            size: 'small',
                            variant: 'outlined',
                            color: 'secondary',
                            children: /*#__PURE__*/ React.createElement(MessageOutlined, {
                                color: "success"
                            }),
                            setFormState: handleCommunicationsClick,
                            sx: {
                                p: 1,
                                fontSize: 'sm'
                            },
                            containerProps: {
                                display: 'flex',
                                flexDirection: 'column-reverse',
                                justifyContent: 'center',
                                alignItems: 'center',
                                gap: 0.5
                            },
                            labelTypographyProps: {
                                mb: 0
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: 'Call',
                            label: 'Call',
                            columnSize: 3,
                            size: 'small',
                            variant: 'outlined',
                            color: 'secondary',
                            children: /*#__PURE__*/ React.createElement(CallOutlined, {
                                color: "info"
                            }),
                            setFormState: handleCommunicationsClick,
                            sx: {
                                p: 1,
                                fontSize: 'sm'
                            },
                            containerProps: {
                                display: 'flex',
                                flexDirection: 'column-reverse',
                                justifyContent: 'center',
                                alignItems: 'center',
                                gap: 0.5
                            },
                            labelTypographyProps: {
                                mb: 0
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: 'WhatsApp',
                            label: 'Whatsapp',
                            columnSize: 3,
                            size: 'small',
                            variant: 'outlined',
                            color: 'secondary',
                            children: /*#__PURE__*/ React.createElement(WhatsApp, {
                                color: "success"
                            }),
                            setFormState: handleCommunicationsClick,
                            sx: {
                                p: 1,
                                fontSize: 'sm'
                            },
                            containerProps: {
                                display: 'flex',
                                flexDirection: 'column-reverse',
                                justifyContent: 'center',
                                alignItems: 'center',
                                gap: 0.5
                            },
                            labelTypographyProps: {
                                mb: 0
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: 'Email',
                            label: 'Email',
                            columnSize: 3,
                            size: 'small',
                            variant: 'outlined',
                            color: 'secondary',
                            children: /*#__PURE__*/ React.createElement(EmailOutlined, {
                                color: "error"
                            }),
                            setFormState: handleCommunicationsClick,
                            sx: {
                                p: 1,
                                fontSize: 'sm'
                            },
                            containerProps: {
                                display: 'flex',
                                flexDirection: 'column-reverse',
                                justifyContent: 'center',
                                alignItems: 'center',
                                gap: 0.5
                            },
                            labelTypographyProps: {
                                mb: 0
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: 'BookAppointment',
                            columnSize: 12,
                            size: 'small',
                            variant: 'contained',
                            fullWidth: true,
                            children: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Add, {
                                color: "inherit"
                            }), " Book appointment"),
                            sx: {
                                width: '100%'
                            },
                            onClick: function (e, state) {
                                var _state$Vehicle6;
                                dispatch(showSurface({
                                    type: 'Dialog',
                                    containerProps: {
                                        fullWidth: true,
                                        maxWidth: 'md'
                                    },
                                    Component: CreateAppointment,
                                    componentProps: {
                                        view: 'telecaller',
                                        request: {
                                            Key: 'VinNo',
                                            Value: state === null || state === void 0 || (_state$Vehicle6 = state.Vehicle) === null || _state$Vehicle6 === void 0 ? void 0 : _state$Vehicle6.Vin
                                        }
                                    }
                                }));
                            }
                        }]
                }, {
                    type: FormItemTypes.Divider,
                    name: '',
                    variant: 'fullWidth',
                    sx: {
                        bgcolor: 'secondary'
                    },
                    columnSize: 12
                },
                // Divider
                {
                    type: FormItemTypes.Accordian,
                    name: 'ComplaintsAccordian',
                    columnSize: 12,
                    value: false,
                    sx: {
                        border: 'none'
                    },
                    summary: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            columnSize: 0,
                            children: 'Complaints',
                            fontSize: 'lg',
                            fontWeight: 'strong'
                        }],
                    elements: [{
                            type: FormItemTypes.CardComponent,
                            name: '',
                            columnSize: 12,
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: 'ServiceDate',
                                    label: '',
                                    columnSize: 12,
                                    fontSize: 'sm',
                                    color: 'secondary',
                                    noWrap: true,
                                    flexWrap: 'nowrap',
                                    valueGetter: function (state, field) {
                                        var _state$Complaint, _field$name7;
                                        return dayjs(state === null || state === void 0 || (_state$Complaint = state.Complaint) === null || _state$Complaint === void 0 ? void 0 : _state$Complaint[(_field$name7 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name7 !== void 0 ? _field$name7 : '']).format('DD MMM, YYYY - hh:mm A');
                                    }
                                }, {
                                    type: FormItemTypes.Custom,
                                    name: 'ComplaintStatus',
                                    columnSize: 12,
                                    element: function (_ref3) {
                                        var _value$Complaint;
                                        var value = _ref3.value, _a = _ref3.name, name = _a === void 0 ? '' : _a;
                                        return /*#__PURE__*/ React.createElement(Chip, {
                                            label: value === null || value === void 0 || (_value$Complaint = value.Complaint) === null || _value$Complaint === void 0 ? void 0 : _value$Complaint[name],
                                            color: "secondary",
                                            variant: "filled",
                                            size: "small"
                                        });
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'CustomerVoiceRemarks',
                                    label: '',
                                    columnSize: 12,
                                    fontSize: 'sm',
                                    valueGetter: function (state, field) {
                                        var _state$Complaint2, _field$name8;
                                        return state === null || state === void 0 || (_state$Complaint2 = state.Complaint) === null || _state$Complaint2 === void 0 ? void 0 : _state$Complaint2[(_field$name8 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name8 !== void 0 ? _field$name8 : ''];
                                    }
                                }],
                            contentProps: {
                                spacing: 0,
                                rowGap: 1
                            },
                            setFieldProps: function (state) {
                                if (!(state !== null && state !== void 0 && state.Complaint))
                                    return {
                                        type: FormItemTypes.Typography,
                                        children: 'No complaints',
                                        align: 'center',
                                        color: 'secondary'
                                    };
                                return {
                                    type: FormItemTypes.CardComponent,
                                    sx: {
                                        display: 'block',
                                        borderLeft: '4px solid crimson'
                                    }
                                };
                            }
                        }]
                }, {
                    type: FormItemTypes.Divider,
                    name: '',
                    variant: 'fullWidth',
                    sx: {
                        bgcolor: 'secondary'
                    },
                    columnSize: 12
                },
                // Divider
                {
                    type: FormItemTypes.Accordian,
                    name: 'ServiceAccordian',
                    columnSize: 12,
                    value: false,
                    sx: {
                        border: 'none'
                    },
                    summary: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            columnSize: 0,
                            children: 'Service history',
                            fontSize: 'lg',
                            fontWeight: 'strong'
                        }],
                    elements: [{
                            type: FormItemTypes.List,
                            name: 'ServiceHistoryList',
                            columnSize: 12,
                            value: null,
                            variant: 'comfortable',
                            columns: serviceHistoryListColumns,
                            disableCheckboxSelection: true,
                            disableDetailsPanel: true,
                            rowHeight: 50,
                            cellStyles: {
                                px: 1
                            }
                        }]
                }, {
                    type: FormItemTypes.Divider,
                    name: '',
                    variant: 'fullWidth',
                    sx: {
                        bgcolor: 'secondary'
                    },
                    columnSize: 12
                },
                // Divider
                {
                    type: FormItemTypes.ContainerItem,
                    name: 'Communication',
                    columnSize: 12,
                    p: 2,
                    spacing: 0,
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            columnSize: true,
                            children: 'Communication history',
                            fontSize: 'lg',
                            fontWeight: 'strong'
                        }, {
                            type: FormItemTypes.Button,
                            name: 'ViewCommunicationHistory',
                            columnSize: 0,
                            size: 'small',
                            color: 'secondary',
                            children: 'View all',
                            endIcon: /*#__PURE__*/ React.createElement(ChevronRight, null),
                            sx: {
                                p: 0
                            },
                            onClick: function (e, state) {
                                dispatch(showSurface({
                                    type: 'Dialog',
                                    Component: CommunicationTimeline,
                                    componentProps: {
                                        value: state
                                    }
                                }));
                            }
                        }]
                }, {
                    type: FormItemTypes.Divider,
                    name: '',
                    variant: 'fullWidth',
                    sx: {
                        bgcolor: 'secondary'
                    },
                    columnSize: 12
                },
                // Divider
                {
                    type: FormItemTypes.Accordian,
                    name: 'OffersAccordian',
                    columnSize: 12,
                    value: false,
                    sx: {
                        border: 'none'
                    },
                    summary: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            columnSize: 0,
                            children: 'Offers',
                            fontSize: 'lg',
                            fontWeight: 'strong'
                        }],
                    elements: [{
                            type: FormItemTypes.CardComponent,
                            name: 'OffersCard',
                            columnSize: 12,
                            label: 'New year discount',
                            headerProps: {
                                titleTypographyProps: {
                                    fontSize: 'lg',
                                    fontWeight: 'strong'
                                }
                            },
                            contentProps: {
                                spacing: 0,
                                p: 0
                            },
                            sx: {
                                background: secondary[50]
                            },
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: 'Discount',
                                    columnSize: 8,
                                    children: '15% OFF',
                                    fontSize: 24,
                                    fontWeight: "strong",
                                    color: 'info.main'
                                }, {
                                    type: FormItemTypes.Button,
                                    name: '',
                                    columnSize: 4,
                                    children: 'Avail',
                                    variant: 'outlined',
                                    color: 'secondary',
                                    size: 'small',
                                    fullWidth: true,
                                    sx: {
                                        py: 0
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    columnSize: 6,
                                    children: 'on the next service',
                                    fontSize: 'sm',
                                    color: 'text.tertiary',
                                    containerProps: {
                                        py: '0px!important'
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    columnSize: 6,
                                    children: 'valid till Dec 31',
                                    fontSize: 'sm',
                                    color: 'text.tertiary',
                                    align: 'right',
                                    containerProps: {
                                        py: '0px!important'
                                    }
                                }]
                        }]
                }, {
                    type: FormItemTypes.Divider,
                    name: '',
                    variant: 'fullWidth',
                    sx: {
                        bgcolor: 'secondary'
                    },
                    columnSize: 12
                } // Divider
            ]
        }];
    return /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        mode: "edit",
        getFormAPI: crmCustomerProfileGet,
        getKey: CRMKeys.get,
        getRequest: _objectSpread({
            id: id
        }, request),
        formData: formData,
        gridSpacing: 0,
        formProps: {
            minHeight: 'calc(100svh - 64px)'
        },
        gridProps: {
            bgcolor: 'secondary.50'
        }
    });
}
